import * as React from 'react';
import {useEffect, useState} from 'react';
import {ActivityIndicator, FlatList, Platform, RefreshControl, StyleSheet, Text, View,} from 'react-native';
import PreLoader from '../../components/PreLoader';
import config from '../../utils/config';
import Axios from 'axios';
import HandleHTTPError from '../../utils/handleErrors';
import {Container} from "native-base";
import {SafeAreaView} from "react-native-safe-area-context";
import CapexDetailComponent from "../../components/capex/CapexDetailComponent";

export default function CapexUsageComponent({navigation, route}) {
    const capex = route.params?.capex;
    const [working, setWorking] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [next, setNext] = useState(null);
    const [capexUsage, setCapexUsage] = useState([]);

    useEffect(() => {
        console.log(capex)
        getCapexUsage(true);
    }, []);

    const getCapexUsage = async (initial = false) => {
        if (working || loadingMore) return;

        if (initial) setWorking(true);
        const uri = initial
            ? `${config.api.host}projects/capex/history/${capex.id}`
            : next;

        try {
            const {data} = await Axios.get(uri, {
                headers: config.api.headers,
            });

            setNext(data.next);
            setCapexUsage((prev) => (initial ? data.results : [...prev, ...data.results]));
        } catch (error) {
            HandleHTTPError(error, navigation);
        } finally {
            if (initial) setWorking(false);
            setRefreshing(false);
            setLoadingMore(false);
        }
    };

    const handleRefresh = () => {
        setRefreshing(true);
        getCapexUsage(true);
    };

    const handleLoadMore = () => {
        if (next && !loadingMore) {
            setLoadingMore(true);
            getCapexUsage(false);
        }
    };

    const translateChange = (key, oldValue, newValue) => {
        const labels = {
            current_budget: 'Presupuesto actual',
            budget: 'Presupuesto inicial',
            ascii: 'ASCII',
            code: 'Código',
            code_sub: 'Subcódigo',
            name: 'Nombre',
            description: 'Descripción',
            approved: 'Aprobado',
            budgeted: 'Presupuestado',
            year: 'Año',
            is_auto: 'Automático',
            q: 'Cantidad',
            is_unavailable: 'Disponible',
        };

        const formatValue = (value) => {
            if (typeof value === 'boolean') return value ? 'Sí' : 'No';
            if (typeof value === 'number' && key.includes('budget')) return `$${value.toLocaleString()}`;
            return String(value);
        };

        const label = labels[key] || key;

        return `${label}: ${formatValue(oldValue)} -> ${formatValue(newValue)}`;
    };

    const renderItem = ({item}) => (
        <View style={styles.itemContainer}>
            <Text style={styles.name}>{item.name} - {item.code}.{item.code_sub}</Text>
            <Text style={styles.date}>{new Date(item.history_date).toLocaleString()}</Text>
            {item.diff && Object.keys(item.diff).length > 0 && (
                <View style={styles.diffContainer}>
                    <Text style={styles.diffTitle}>Cambios:</Text>
                    {Object.entries(item.diff).map(([key, value]) => (
                        <Text key={key} style={styles.diffItem}>
                            {translateChange(key, value.old, value.new)}
                        </Text>
                    ))}
                </View>
            )}
        </View>
    );


    const EmptyListMessage = () => (
        <View style={styles.emptyContainer}>
            <Text style={styles.emptyText}>No hay información para mostrar</Text>
        </View>
    );


    if (working && !refreshing) {
        return <PreLoader/>;
    }

    return (
        <Container style={styles.container}>
            <SafeAreaView style={styles.content}>
                <FlatList
                    data={capexUsage}
                    keyExtractor={(item) => `${item.history_id}`}
                    renderItem={renderItem}
                    refreshControl={
                        <RefreshControl refreshing={refreshing} onRefresh={handleRefresh}/>
                    }
                    onEndReached={handleLoadMore}
                    onEndReachedThreshold={0.3}
                    ListHeaderComponent={<View style={{marginHorizontal: 12}}><CapexDetailComponent
                        capex={capex}/></View>}
                    ListEmptyComponent={EmptyListMessage}
                    ListFooterComponent={
                        loadingMore ? <ActivityIndicator size="small" style={{margin: 10}}/> : null
                    }
                    contentContainerStyle={{
                        paddingBottom: 20,
                        flexGrow: 1,
                    }}
                />
            </SafeAreaView>
        </Container>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#ecf0f1',
    },
    content: {
        flex: 1,
        padding: 10,
        ...(Platform.OS === "web" && {
            width: "50%",
            alignSelf: "center",
        }),
    },
    itemContainer: {
        backgroundColor: '#ffffff',
        marginHorizontal: 12,
        marginVertical: 4,
        padding: 14,
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.05,
        shadowRadius: 4,
        elevation: 2,
    },
    name: {
        fontWeight: 'bold',
        fontSize: 16,
        color: '#2c3e50',
    },
    date: {
        fontSize: 12,
        color: '#95a5a6',
        marginVertical: 4,
    },
    budget: {
        fontSize: 13,
        color: '#16a085',
        fontWeight: '500',
    },
    diffContainer: {
        marginTop: 10,
        backgroundColor: '#ecf0f1',
        padding: 10,
        borderRadius: 6,
    },
    diffTitle: {
        fontWeight: '600',
        color: '#2c3e50',
        marginBottom: 4,
    },
    diffItem: {
        fontSize: 13,
        color: '#34495e',
    },
    emptyContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 40,
    },
    emptyText: {
        fontSize: 16,
        color: '#bdc3c7',
    },
});
